export default "__VITE_PUBLIC_ASSET__86c4ebb8__"